// src/services/AuthErrorHandler.tsx

import KeyCloakService from '@/security/KeycloakService';

let authErrorShown = false; // Prevent multiple dialogs

/**
 * Handles authentication errors gracefully without breaking SSO
 */
export class AuthErrorHandler {
  /**
   * Handle 401 errors gracefully without automatic logout
   */
  static handleAuthError(error: any, context: string = 'API call') {
    console.warn(`Authentication error in ${context}:`, error);
    this.attemptReauth();

  }
  
  /**
   * Attempt re-authentication without breaking SSO
   */
  static async attemptReauth() {
    try {
      console.log('Attempting re-authentication...');
      
      // Try to update token with a longer validity period
      const updated = await KeyCloakService.RefreshTokenWithRetry();
      
      if (updated) {
        console.log('Re-authentication successful');
        authErrorShown = false;
        
        // Optionally reload the page to refresh the application state
        if (confirm('Autenticación exitosa. ¿Desea recargar la página para actualizar los datos?')) {
          window.location.reload();
        }
      } else {
        console.warn('Re-authentication failed, trying login redirect');
        
        // As a last resort, redirect to login (this will preserve SSO if available)
        KeyCloakService.GetToken() || KeyCloakService.CallLogin();
      }
    } catch (error) {
      console.error('Re-authentication failed:', error);
      
      // Show a more specific error message
      alert(
        'No se pudo reautenticar automáticamente. ' +
        'Por favor, recargue la página o contacte al administrador del sistema.'
      );
    } finally {
      authErrorShown = false;
    }
  }
  
  /**
   * Reset the error state (call this when user successfully authenticates)
   */
  static resetErrorState() {
    authErrorShown = false;
  }
}

export default AuthErrorHandler;